import { getInitState } from '../global'

const initStateFunc = getInitState({
  FUBONTabAccessibility: true
})


export const accessibilityFunctions = {
  hasTabIndex
}

function hasTabIndex({ tabIndex } = {}) {
  return initStateFunc('TTLTabAccessibility') ? { tabIndex: tabIndex || '0'  } : {}
}